import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { load, connectMoreNews } from 'modules/Common/reducers/morenews';
import { loadMediaForArticles } from 'modules/Common/reducers/media';

import TipsSection from '../components/TipsSection';

const TIPS_PATH = '/racing/tips-centre';

@layoutAsyncConnect(
  "RacingTips",
  [{
    dispatch: () => load(TIPS_PATH, 3),
    state: connectMoreNews,
    then: ({dispatch, state, result: {articles}}) => loadMediaForArticles(state, dispatch, articles)
  }]
)
export default class RacingTips extends Component {
  static propTypes = {
    plainTitle: PropTypes.bool,
    news: PropTypes.object
  };

  render() {
    const {
      news: {
        [TIPS_PATH]: {
          articles: tipsItems = []
        } = {}
      } = {},
      plainTitle
    } = this.props;

    const componentData = {
      plainTitle,
      sectionLabel: "Racing",
      sectionLink: "/racing",
      additionalTipsLinks: [
        {text: "All Racing Tips", href: "/racing/tips-centre"}
      ],
      tipsItems: tipsItems.slice(0, 3)
    };

    return (
      <TipsSection {...componentData} />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/RacingTips.js